<script lang="ts">
	/**
	 * ScrollReveal — slot wrapper that fades children in on entry.
	 *
	 * Built on the `scrollReveal` action (lib/actions). Use the action
	 * directly when you need it on an element you control; this wrapper
	 * exists for snippet-based uses where adding `use:` requires a
	 * leaf element.
	 */
	import type { Snippet } from 'svelte';
	import { scrollReveal } from '$lib/actions/scroll-reveal';

	interface Props {
		threshold?: number;
		once?: boolean;
		class?: string;
		children: Snippet;
	}

	let { threshold = 0.12, once = true, class: className = '', children }: Props = $props();
</script>

<div class="reveal {className}" use:scrollReveal={{ threshold, once }}>
	{@render children()}
</div>
